import { ChevronDown, ChevronFirst, ChevronLast, ChevronUp } from 'lucide-react'

import { TableCell } from '@/components/ui/table'

const _TableCell = () => {
  return (
    <TableCell className="py-0">
      <div className="flex items-center gap-1">
        <div className="flex items-center gap-1">
          <ChevronFirst
            size={20}
            onClick={() => onClickMove(-Infinity)}
            className="rotate-90 cursor-pointer rounded hover:bg-muted-foreground/20"
          />
          <ChevronUp
            size={20}
            onClick={() => onClickMove(-1)}
            className="cursor-pointer rounded hover:bg-muted-foreground/20"
          />
        </div>
        <div className="flex items-center gap-1">
          <ChevronLast
            size={20}
            onClick={() => onClickMove(+Infinity)}
            className="rotate-90 cursor-pointer rounded hover:bg-muted-foreground/20"
          />
          <ChevronDown
            size={20}
            onClick={() => onClickMove(1)}
            className="cursor-pointer rounded hover:bg-muted-foreground/20"
          />
        </div>
      </div>
    </TableCell>
  )
}

export const SimpleTableReorder = {
  TableCell: _TableCell,
}
